// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: GothamRounded-Book;
  src: local('Gotham Rounded Book'), local('GothamRounded-Book');
}

@font-face {
  font-family: GothamRounded-Medium;
  src: local('Gotham Rounded Medium'), local('GothamRounded-Medium');
}

@font-face {
  font-family: GothamRounded-Bold;
  src: local('Gotham Rounded Bold'), local('GothamRounded-Bold');
}

@font-face {
  font-family: GothamXNarrow-Book;
  src: local('Gotham XNarrow Book'), local('GothamXNarrow-Book');
}

@font-face {
  font-family: GothamXNarrow-Medium;
  src: local('Gotham XNarrow Medium'), local('GothamXNarrow-Medium');
}

@font-face {
  font-family: GothamXNarrow-Bold;
  src: local('Gotham XNarrow Bold'), local('GothamXNarrow-Bold');
}

body {
  margin: 0;
}

:root {
  --hsl-blue: rgb(0, 122, 201);
  --timetable-text-color: rgb(0, 122, 201);
  --hsl-blue-light: rgb(213, 232, 250);
  --background: var(--hsl-blue);
  --light-background: var(--hsl-blue-light);
  --border-radius: 56px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,8DAA8D;AAChE;;AAEA;EACE,iCAAiC;EACjC,kEAAkE;AACpE;;AAEA;EACE,+BAA+B;EAC/B,8DAA8D;AAChE;;AAEA;EACE,+BAA+B;EAC/B,8DAA8D;AAChE;;AAEA;EACE,iCAAiC;EACjC,kEAAkE;AACpE;;AAEA;EACE,+BAA+B;EAC/B,8DAA8D;AAChE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,oCAAoC;EACpC,6BAA6B;EAC7B,yCAAyC;EACzC,qBAAqB;AACvB","sourcesContent":["@font-face {\n  font-family: GothamRounded-Book;\n  src: local('Gotham Rounded Book'), local('GothamRounded-Book');\n}\n\n@font-face {\n  font-family: GothamRounded-Medium;\n  src: local('Gotham Rounded Medium'), local('GothamRounded-Medium');\n}\n\n@font-face {\n  font-family: GothamRounded-Bold;\n  src: local('Gotham Rounded Bold'), local('GothamRounded-Bold');\n}\n\n@font-face {\n  font-family: GothamXNarrow-Book;\n  src: local('Gotham XNarrow Book'), local('GothamXNarrow-Book');\n}\n\n@font-face {\n  font-family: GothamXNarrow-Medium;\n  src: local('Gotham XNarrow Medium'), local('GothamXNarrow-Medium');\n}\n\n@font-face {\n  font-family: GothamXNarrow-Bold;\n  src: local('Gotham XNarrow Bold'), local('GothamXNarrow-Bold');\n}\n\nbody {\n  margin: 0;\n}\n\n:root {\n  --hsl-blue: rgb(0, 122, 201);\n  --timetable-text-color: rgb(0, 122, 201);\n  --hsl-blue-light: rgb(213, 232, 250);\n  --background: var(--hsl-blue);\n  --light-background: var(--hsl-blue-light);\n  --border-radius: 56px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
